import { Component, OnInit, ViewChild } from "@angular/core";
import moment from "moment";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { LocalStorageService } from "../shared/local-storage.service";
import { Pilot } from "../shared/models/pilot.model";
import { MatTable } from "@angular/material/table";
import { TranslateService } from "@ngx-translate/core";
import { TooltipPosition } from "@angular/material/tooltip";
import { StatisticPilotHoursService } from "./statistic-pilot-hours.service";

@Component({
    selector: "app-statistic-pilot-hours",
    templateUrl: "./statistic-pilot-hours.component.html",
    styleUrls: ["./statistic-pilot-hours.component.scss"],
    standalone: false,
})
export class StatisticPilotHoursComponent implements OnInit {
    @ViewChild("statisticTable", { static: false }) statisticTable: MatTable<any>;

    public statisticFilterForm: FormGroup;
    public displayedColumns: string[] = ["pilotName", "prev28Days", "prev7Days", "selectedDate"];
    positionOptions: TooltipPosition[] = ["below", "above", "left", "right"];
    position = new FormControl(this.positionOptions[0]);

    public dataTable = [];
    public pilotsOptions: Pilot[] = [];

    private _userSessionObject;

    public minDate = new Date();
    public currentDate = moment(this.minDate).format("DD/MM/YYYY");

    constructor(
        private _formBuilder: FormBuilder,
        private _localStorageService: LocalStorageService,
        private _translate: TranslateService,
        private _statisticPilotHoursService: StatisticPilotHoursService,
    ) {
        this._userSessionObject = this._localStorageService.getUserLocalStorageObject();
        this.statisticFilterForm = this._formBuilder.group({
            currentDate: moment(this.minDate).format("YYYY-MM-DD"),
            pilotId: [],
        });
    }

    ngOnInit(): void {
        this._statisticPilotHoursService.getStatisticData(this._userSessionObject.organizationId.toString(), moment(this.minDate).format("YYYY-MM-DD")).subscribe((result) => {
            this.dataTable = result;
        });
    }

    updateCalcs(event) {
        const dateEvent: Date = event.value;
        this.currentDate = moment(dateEvent).format("DD/MM/YYYY");
        this._statisticPilotHoursService.getStatisticData(this._userSessionObject.organizationId.toString(), moment(dateEvent).format("YYYY-MM-DD")).subscribe((result) => {
            this.dataTable = result;
        });
    }

    getCssStyle(perc: number): object {
        if (perc < 100) {
            return { width: perc + "%" };
        } else {
            return { width: "100%", "background-color": "red" };
        }
    }
    getLabel(doneVal: string, todoVal: string, remainingVal: string) {
        let label = "";
        label =
            this._translate.instant("STATISTICPILOTHOURS.progBarLabelDone").replace("%Value%", doneVal) +
            " / " +
            this._translate.instant("STATISTICPILOTHOURS.progBarLabelTodo").replace("%Value%", todoVal) +
            " / " +
            this._translate.instant("STATISTICPILOTHOURS.progBarLabelRemaining").replace("%Value%", remainingVal);
        return label;
    }

    addDays(dateS: string, days: number, format: string): string {
        return moment(dateS, format).add(days, "days").format(format);
    }
}
